function getRandomSampleFromArray({
  array,
  sampleSize
}) {
  return [...array].sort(() => 0.5 - Math.random()).slice(0, sampleSize);
}

export { getRandomSampleFromArray };
